/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import { IWebtopUrlInputConfig } from './Model';
import { launchPortalAccessResource } from 'apmui/resource/portalAccess/Model';
import onKeyPress, { KEY_CODES } from 'apmui/util/onKeyPress';
import bind from 'apmui/decorators/bind';

interface IUrlInputViewState {
    value: string;
}

class UrlInputView extends React.Component<IWebtopUrlInputConfig, IUrlInputViewState> {
    state: IUrlInputViewState = { value: '' };

    @bind
    onClick() {
        if (this.state.value) {
            // prepare URL
            let url = this.state.value
                .trim()
                // filter out any scheme except for http: and https:; scheme-less URL also accepted
                .replace(/^(?:(https?:\/\/)|[a-z]*:\/\/.*)(.*)$/i, '$1$2');
            if (url) {
                // add scheme if there is no one
                url = url.replace(/(?:http(s?):\/\/)?(.+)$/i, 'http$1://$2');
                // launch Portal Access with resulting URL
                launchPortalAccessResource(url);
            }
            this.setState({ value: '' });
        }
    }

    @bind
    onChange(evt: React.FormEvent<HTMLInputElement>) {
        this.setState({ value: (evt.target as HTMLInputElement).value });
    }

    render() {
        return (
            <div className="apmui-input-text" id="webtop-url-input">
                <img src="/public/images/modern/webtop/url-input.png" alt="" className="apmui-input--icon" />
                <input
                    placeholder={this.props.title}
                    title={this.props.title}
                    aria-label={this.props.title}
                    onInput={this.onChange}
                    onKeyPress={onKeyPress(this.onClick, [KEY_CODES.ENTER])}
                    value={this.state.value}
                />
                <button id="webtop-url-go" onClick={this.onClick}>
                    <img src="/public/images/modern/webtop/url-input-go.png" alt="" />
                </button>
            </div>
        );
    }
}

export default UrlInputView;
